<div fxLayout="column">
  <div class="avatar-upload">
    <div class="avatar-edit">
        <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileVariable
        (click)="$event.stopPropagation()"/>
        <label for="imageUpload"></label>
        <mat-progress-spinner [diameter]="25" [value]="progress" *ngIf="progress > 0"></mat-progress-spinner>
    </div>
    <div class="avatar-preview">
        <div id="imagePreview">
          <img onerror='this.onerror=null;this.src="../../../../../assets/images/icons/user-placeholder.svg";'
          src="http://trek.hashtheme.com/ce/cleveland-preview3/cleveland/assets/img/team/tes2.jpg" alt="img" />
        </div>
    </div>
</div>
</div>
